import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_REPORTS_CURRENT_ORDERS_FAILED,
  GET_REPORTS_CURRENT_ORDERS_SUCCESS,
  GET_REPORTS_CURRENT_ORDERS,
  GET_REPORTS_CENTER_ORDERS_FAILED,
  GET_REPORTS_CENTER_ORDERS_SUCCESS,
  GET_REPORTS_CENTER_ORDERS,
} from './constants';

import {
  GetReportsCurrentOrdersRequestBuilder,
  GetReportsCenterOrdersRequestBuilder,
} from 'client-sdk/src/reports/reports';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import {flattenObject} from '../../utils/helpers';

const token = localStorage.getItem('token') || '';

export function* getReportsCurrentOrders(actions: any): unknown {
  try {
    const makeRequest = new GetReportsCurrentOrdersRequestBuilder().build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_REPORTS_CURRENT_ORDERS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_REPORTS_CURRENT_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getReportsCenterOrders(actions: any): unknown {
  try {
    const makeRequest = new GetReportsCenterOrdersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_REPORTS_CENTER_ORDERS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_REPORTS_CENTER_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* userSaga() {
  yield takeLatest(GET_REPORTS_CURRENT_ORDERS, getReportsCurrentOrders);
  yield takeLatest(GET_REPORTS_CENTER_ORDERS, getReportsCenterOrders);
}
